import { useEffect, useState } from 'react';
import { fetchProjectVisitSelections } from '../../studyConfiguration/studyConfigurationApi';

function pickItems(data) {
  const raw = data?.items ?? data?.Items ?? [];
  return Array.isArray(raw) ? raw : [];
}

function toOption(item) {
  const value = String(item?.visitCode ?? item?.VisitCode ?? '').trim();
  const label = String(item?.visitName ?? item?.VisitName ?? value).trim() || value;
  return value ? { value, label } : null;
}

function isSelected(item) {
  return item?.isSelected === true || item?.IsSelected === true;
}

export function mapProjectVisitTypeOptions(data) {
  const items = pickItems(data);
  const selected = items.filter(isSelected).map(toOption).filter(Boolean);
  if (selected.length > 0) return selected;
  return items.map(toOption).filter(Boolean);
}

export function mapProjectVisitTypeNameByCode(data) {
  const map = {};
  pickItems(data).forEach((item) => {
    const opt = toOption(item);
    if (opt) map[opt.value.toUpperCase()] = opt.label;
  });
  return map;
}

/**
 * Report visit-type dropdown: project-assigned types, else all active master types.
 * Does not use schedule-visit-types (site + study-design lane).
 */
export default function useProjectVisitTypeOptions(projectCode) {
  const [options, setOptions] = useState([]);
  const [nameByCode, setNameByCode] = useState({});

  useEffect(() => {
    let cancelled = false;
    const code = (projectCode || '').toString().trim();
    if (!code) {
      setOptions([]);
      setNameByCode({});
      return undefined;
    }
    fetchProjectVisitSelections(code)
      .then((res) => {
        if (cancelled) return;
        setOptions(mapProjectVisitTypeOptions(res.data));
        setNameByCode(mapProjectVisitTypeNameByCode(res.data));
      })
      .catch(() => {
        if (!cancelled) {
          setOptions([]);
          setNameByCode({});
        }
      });
    return () => { cancelled = true; };
  }, [projectCode]);

  return { options, nameByCode };
}
